/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.23",
    versionName: "0.8.0-nightly.2026.10.23",
    versionChannel: "nightly",
    buildDate: "2026-10-23T00:16:35.991Z",
    commitHash: "029c6633bc0f6cece6be18b9c56f7dad20ad3c95",
};
